// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconKnife = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M15.19 1v21.995h-2V17.33H9l-1-1V5a4 4 0 014-4zm-2 14.33V3H12a2 2 0 00-2 2v10.33z" />
  );
export default SvgIconKnife;
